export default {
  custom_additive: {
    placeholder: 'Add custom option',
  },
  buttons: {
    add: 'Add',
  },
};
